import React from 'react';

import { Group, Title } from '@mantine/core';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import AssignPayRatesTable from './components/AssignPayRatesTable';

const AssignRates = (): JSX.Element => {
  const { hasPerm } = useAuth();
  const payrollPerm = hasPerm('PayrollMutate');

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Assign Rates
          </Title>
        </Group>
      </PageHeader>
      <AssignPayRatesTable permission={payrollPerm} />
    </>
  );
};

export default AssignRates;
